import { Button } from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import { useServiceNeedContext, QuestionSteps } from "../../context/ServiceNeedContext";

const ActionButton = ({
  isLoading,
  goToInitialQuestionStep,
  goToFinalQuestionStep,
  handleUpdateAndLogin,
}: {
  isLoading: boolean;
  goToInitialQuestionStep: () => void;
  goToFinalQuestionStep: () => void;
  handleUpdateAndLogin: () => Promise<void>;
}) => {
  const { questionStep } = useServiceNeedContext();
  const { t } = useTranslation();

  let handleClick: () => void | Promise<void>;
  let buttonText: string;

  switch (questionStep) {
    case QuestionSteps.INITIAL:
      handleClick = goToFinalQuestionStep;
      buttonText = t("OnlineStatus.NextQuestion");
      break;
    default:
      handleClick = handleUpdateAndLogin;
      buttonText = t("OnlineStatus.GoToBankAccountSettings");
      break;
  }

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {questionStep === QuestionSteps.FINAL && (
          <Button
            variant="secondary"
            onClick={goToInitialQuestionStep}
            style={{ marginRight: "8px" }}
          >
            {t("OnlineStatus.PreviousQuestion")}
          </Button>
        )}
      <Button isLoading={isLoading} onClick={handleClick}>
        {buttonText}
      </Button>
    </div>
  );
};

export default ActionButton;